export class Jump {
    constructor(op, pc) {
        this.op = op;
        this.pc = pc;
    }
}

//# sourceMappingURL=Jump.js.map
